import { referentialCacheService } from "../../services/referentialCacheService";
import { ReferentialSyncActions } from "../types";
import { initReferentials } from "./initReferentials";

/**
 * Vide le cache et remet à zéro le state
 */
export const clearCache = async (
  actions: ReferentialSyncActions
): Promise<void> => {
  try {
    referentialCacheService.clearCache();
    actions.reset();
    console.log('Cache des référentiels vidé');
  } catch (error) {
    console.error('Erreur lors de la suppression du cache:', error);
    actions.setError('Erreur lors de la suppression du cache');
  }
};

/**
 * Force le rechargement des référentiels en ignorant le cache
 */
export const refreshReferentials = async (
  actions: ReferentialSyncActions
): Promise<void> => {
  try {
    // Vider le cache d'abord
    referentialCacheService.clearCache();
    console.log('Cache vidé, rechargement forcé des référentiels');
    
    // Puis recharger depuis l'API
    await initReferentials(actions);
  } catch (error) {
    console.error('Erreur lors du rechargement des référentiels:', error);
    actions.setError('Erreur lors du rechargement des référentiels');
  }
};
